import React from 'react';
import { motion } from 'framer-motion';
const bubbles = [{
  left: '18%',
  size: 8,
  delay: 0,
  duration: 1.3,
  drift: 10
}, {
  left: '32%',
  size: 5,
  delay: 0.25,
  duration: 1.1,
  drift: -8
}, {
  left: '46%',
  size: 11,
  delay: 0.1,
  duration: 1.5,
  drift: 6
}, {
  left: '58%',
  size: 6,
  delay: 0.4,
  duration: 1.2,
  drift: -12
}, {
  left: '70%',
  size: 9,
  delay: 0.15,
  duration: 1.4,
  drift: 9
}, {
  left: '82%',
  size: 4,
  delay: 0.5,
  duration: 1.0,
  drift: -6
}, {
  left: '26%',
  size: 6,
  delay: 0.55,
  duration: 1.25,
  drift: 7
}, {
  left: '64%',
  size: 7,
  delay: 0.05,
  duration: 1.35,
  drift: -10
}];
interface SplashScreenProps {
  onComplete: () => void;
}
export function SplashScreen({
  onComplete
}: SplashScreenProps) {
  return <motion.div className="fixed inset-0 z-[100] flex items-center justify-center bg-brand-background overflow-hidden" initial={{
    opacity: 1
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0,
    scale: 1.08,
    filter: 'blur(6px)'
  }} transition={{
    duration: 0.6,
    ease: 'easeInOut'
  }} onAnimationComplete={() => {
    // Trigger handoff after the logo's intro settles
    setTimeout(onComplete, 1100);
  }} aria-hidden="true" data-id="element-293">
      {/* Subtle depth vignette */}
      <div className="absolute inset-0 [background:radial-gradient(120%_90%_at_50%_45%,rgba(0,184,217,0.10)_0%,transparent_55%)]" data-id="element-294" />

      {/* Rising bubbles */}
      {bubbles.map((b, i) => <motion.span key={i} className="absolute rounded-full bg-brand-primary/30" style={{
      left: b.left,
      bottom: '38%',
      width: b.size,
      height: b.size
    }} initial={{
      opacity: 0,
      y: 0
    }} animate={{
      opacity: [0, 0.6, 0],
      y: [-10, -170],
      x: [0, b.drift]
    }} transition={{
      duration: b.duration,
      delay: b.delay,
      ease: 'easeOut'
    }} data-id="element-295" />)}

      {/* Logo wordmark with organic float */}
      <motion.div className="relative z-10 text-center px-6" initial={{
      opacity: 0,
      scale: 0.96,
      y: 8
    }} animate={{
      opacity: 1,
      scale: 1.07,
      y: [8, 0, -4, 0]
    }} transition={{
      opacity: {
        duration: 0.6,
        ease: 'easeOut'
      },
      scale: {
        duration: 1.2,
        ease: 'easeInOut'
      },
      y: {
        duration: 2.4,
        ease: 'easeInOut',
        repeat: Infinity
      }
    }} data-id="element-296">
        <h1 className="text-white font-heading font-black text-3xl sm:text-4xl tracking-wider uppercase leading-tight" data-id="element-297">
          Buceo y<br data-id="element-298" />
          Navegación
        </h1>
        <motion.span className="block mx-auto mt-4 h-px bg-brand-primary/70" initial={{
        width: 0,
        opacity: 0
      }} animate={{
        width: 64,
        opacity: 1
      }} transition={{
        duration: 0.7,
        delay: 0.3,
        ease: 'easeOut'
      }} data-id="element-299" />
      </motion.div>
    </motion.div>;
}